import React from 'react';
import PropTypes from 'prop-types';
import { NavTab, NavTabs } from './navbar-tabs.styles';
import { GTM_ID } from '../../../../common/constants/gtmIds';
import { NavbarColumnProps } from '../navbar-columns/navbar-columns';
import { NavbarDropdown } from '../../components/navbar-dropdown/navbar-dropdown';
import {
  StyledChevronDownAtom,
  StyledChevronUpAtom,
} from '../../atoms/icon-atoms/nav-icon-atoms';
import vars from '../../variables';

export const NavbarTabs = ({
  tabs,
  handleClick,
  selectedTab,
  columnData,
  footerData,
  handleReset,
  textColor,
  isLanguagesOpen,
  translate = true,
}) => {
  const setTextColor = () => {
    if (selectedTab || isLanguagesOpen) {
      return vars.coreDarkGrey;
    }

    return textColor;
  };

  return (
    <NavTabs>
      {tabs.map(tab => {
        const isSelected = tab.contentful_id === selectedTab;

        return (
          <div key={tab.contentful_id}>
            <NavTab
              id={`tab-${tab.contentful_id}`}
              key={tab.contentful_id}
              value={tab.contentful_id}
              onClick={handleClick}
              isSelected={isSelected}
              data-gtm-id={`${GTM_ID.MAIN_NAV_LINK}-${tab.title
                .toLowerCase()
                .split(' ')
                .join('-')}`}
              data-testid="nav-bar-links"
              textColor={setTextColor()}
            >
              {tab.title}
              {isSelected ? (
                <StyledChevronUpAtom stroke={setTextColor()} />
              ) : (
                <StyledChevronDownAtom stroke={setTextColor()} />
              )}
            </NavTab>
            {selectedTab && selectedTab === tab.contentful_id && columnData && (
              <NavbarDropdown
                columnData={columnData}
                handleReset={handleReset}
                footerData={footerData}
                translate={translate}
              />
            )}
          </div>
        );
      })}
    </NavTabs>
  );
};

export const NavbarTabsProps = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      columns: PropTypes.arrayOf(NavbarColumnProps),
    })
  ),
  handleClick: PropTypes.func,
  handleReset: PropTypes.func,
  selectedTab: PropTypes.string,
  columnData: PropTypes.arrayOf(PropTypes.shape(NavbarColumnProps)),
  footerData: PropTypes.arrayOf(
    PropTypes.shape({
      footerLinks: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          path: PropTypes.string,
          isExternal: PropTypes.bool,
        })
      ),
      translate: PropTypes.bool,
    })
  ),
  translate: PropTypes.bool,
};

NavbarTabsProps.propTypes = {
  ...NavbarTabsProps,
};
